/**
 * Global custom scripts for the theme.
 * Loaded via snippets/scripts.liquid (included in the theme layout on every page).
 */

import { StandardEvents } from "@shopify/events";

// Klaviyo signup forms
// categorise and publish events to Shopify analytics
const KLAVIYO_FORM_CATEGORIES = {
  // '<klaviyo_form_id>': '<category>'
  VmggPD: "newsletter_signup",
  TLdCzi: "member_signup",
  RkRqdW: "member_signup",
  XK63Nx: "member_signup",
  VmggPD: "studio_eos_2023",
};

window.addEventListener("klaviyoForms", (event) => {
  if (event.detail.type !== "submit") return;

  const formId = event.detail.formId;
  const form_category = KLAVIYO_FORM_CATEGORIES[formId] ?? "unknown";

  window.Shopify.analytics.publish("custom_klaviyo_form_submitted", {
    form_id: formId,
    form_category,
    user_email_address: event.detail.metaData?.$email,
  });
});

// Product card clicks on collection pages
// publish select_item (GA4) event
// consumed by the custom_select_item subscriber in google-tag-manager.js
document.addEventListener("click", (event) => {
  if (!(event.target instanceof Element)) return;

  const card = event.target.closest(
    "product-card[data-current-collection-title]",
  );
  if (!(card instanceof HTMLElement) || card.hasAttribute("data-no-navigation"))
    return;

  const interactiveElement = event.target.closest(
    'button, input, label, select, [tabindex="1"]',
  );
  if (interactiveElement) return;

  const {
    productId,
    productVendor,
    productCategory,
    variantName,
    price,
    currentCollectionId,
    currentCollectionTitle,
  } = card.dataset;

  // view-event-payload only supplies the product title here
  // variant title and price use dedicated data-* attributes instead
  const viewPayload = JSON.parse(
    card.getAttribute("view-event-payload") || "{}",
  );

  window.Shopify.analytics.publish("custom_select_item", {
    item_list_id: currentCollectionId,
    item_list_name: currentCollectionTitle,
    items: [
      {
        item_id: productId,
        item_name: viewPayload.product?.title,
        item_brand: productVendor,
        item_category: productCategory,
        item_variant: variantName,
        price: parseFloat((Number(price) / 100).toFixed(2)),
        quantity: 1,
      },
    ],
  });
});

// Product card swatch selection on collection pages
// keep data-variant-name and data-price in sync with the selected swatch
// so a later card click reports it, not the SSR-rendered default variant
document.addEventListener(StandardEvents.productSelect, (event) => {
  const card =
    event.target instanceof Element
      ? event.target.closest("product-card[data-current-collection-title]")
      : null;
  if (!(card instanceof HTMLElement)) return;

  event.promise.then(({ variant }) => {
    if (!variant) return;
    card.dataset.variantName = variant.title;
    card.dataset.price = String(
      Math.round(parseFloat(variant.price.amount) * 100),
    );
  });
});

// Reviews.io: dist.js is loaded by the app embed; we call ratingSnippet here to adjust the style.
window.addEventListener("load", () => {
  /** @type {any} */ (window).ratingSnippet?.("ruk_rating_snippet", {
    store: "lotuscrafts",
    mode: "default",
    color: "#ac8700",
    linebreak: false,
    text: "",
    singularText: "",
    lang: "de",
    usePolaris: false,
    showEmptyStars: true,
    showNumericalAverageRating: false,
  });
});
